export const SET_PUSHPIN_EXTENSION = 'SET_PUSHPIN_EXTENSION';
export const PUSHPIN_WORKFLOW_ENABLED = 'PUSHPIN_WORKFLOW_ENABLED';
export const PUSHPIN_WORKFLOW_BEGIN = 'PUSHPIN_WORKFLOW_BEGIN';
export const PUSHPIN_WORKFLOW_END = 'PUSHPIN_WORKFLOW_END';
export const PUSHPIN_ATTRIBUTES_SET = 'PUSHPIN_ATTRIBUTES_SET';
export const PUSHPIN_BATCH_CREATE = 'PUSHPIN_BATCH_CREATE';
export const PUSHPIN_UPDATE = 'PUSHPIN_UPDATE';
export const PUSHPIN_BATCH_CLEAR = 'PUSHPIN_BATCH_CLEAR';
export const PUSHPIN_SELECT = 'PUSHPIN_SELECT';
export const PUSHPINS_DESELECT = 'PUSHPINS_DESELECT';
export const PUSHPIN_DROP_START = 'PUSHPIN_DROP_START';
export const PUSHPIN_DROP_END = 'PUSHPIN_DROP_END';

export const setPushpinExtensionAction = pushpinExtension => ({
  type: SET_PUSHPIN_EXTENSION,
  payload: pushpinExtension,
});

export const enablePushpinWorkflowAction = (enabled) => {
  return {
    type: PUSHPIN_WORKFLOW_ENABLED,
    payload: enabled,
  };
};

export const beginPushpinWorkflow = () => {
  return {
    type: PUSHPIN_WORKFLOW_BEGIN,
  };
};

export const endPushpinWorkflow = () => {
  return {
    type: PUSHPIN_WORKFLOW_END,
  };
};

export const setPushpinAttributesAction = (attributes) => {
  return {
    type: PUSHPIN_ATTRIBUTES_SET,
    payload: attributes,
  };
};

export const batchCreatePushpinAction = (issues, currentSheet) => {
  return {
    type: PUSHPIN_BATCH_CREATE,
    payload: { issues, currentSheet },
  };
};

export const updatePushpinAction = (pushpin) => {
  return {
    type: PUSHPIN_UPDATE,
    payload: pushpin,
  };
};

export const batchClearPushpinAction = (issues) => {
  return {
    type: PUSHPIN_BATCH_CLEAR,
    payload: issues,
  };
};

export const selectPushpinAction = (issue) => {
  return {
    type: PUSHPIN_SELECT,
    payload: issue,
  };
};

export const deselectPushpinsAction = () => {
  return {
    type: PUSHPINS_DESELECT,
    payload: null,
  };
};

export const startDropPushpinAction = (status) => {
  return {
    type: PUSHPIN_DROP_START,
    payload: status,
  };
};

export const endDropPushpinAction = () => {
  return {
    type: PUSHPIN_DROP_END,
    payload: null,
  };
};
